"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealtimeService = exports.ABLY_CONNECTION_OPTS = void 0;
var uuid_1 = require("uuid");
exports.ABLY_CONNECTION_OPTS = {
    disconnectedRetryTimeout: 100,
    suspendedRetryTimeout: 100,
};
var ChannelScope;
(function (ChannelScope) {
    ChannelScope["ORGANIZATION"] = "organization";
    ChannelScope["SYSTEM"] = "system";
    ChannelScope["USER"] = "user";
})(ChannelScope || (ChannelScope = {}));
var RealtimeService = /** @class */ (function () {
    function RealtimeService(ctx, realtime) {
        var _this = this;
        var store = ctx.store;
        this.store = store;
        this.ctx = ctx;
        this.realtime = realtime;
        this.setSessionId();
        if (!localStorage.getItem("clientId")) {
            var id = (0, uuid_1.v4)();
            localStorage.setItem("clientId", id);
            this.clientId = id;
        }
        else {
            this.clientId = localStorage.getItem("clientId");
        }
        this.realtime.connection.on("connected", function () {
            // eslint-disable-next-line no-console
            console.log("Connected to Ably!");
            _this.store.dispatch("chatbotStore/setAblyReady");
            _this.ctx.$tracking.init();
        });
        this.realtime.connection.on("disconnected", function () {
            console.log("Disconnected from Ably");
            _this.ctx.$tracking.disconnect();
        });
        this.realtime.connection.on("failed", function () {
            throw new Error("Failed to connect to Ably!"); // failed connection
        });
    }
    RealtimeService.prototype.setSessionId = function () {
        var sessionId = (0, uuid_1.v4)();
        this.sessionId = sessionId;
        localStorage.setItem("sessionId", sessionId);
        return sessionId;
    };
    /**
     * Subscribe to messages scoped to Organization channel.
     */
    RealtimeService.prototype.subscribeToOrganizationChannel = function (_a, orgId) {
        var channel = _a.channel, topic = _a.topic, cb = _a.cb;
        return this.subscribe({ channel: channel, topic: topic, cb: cb }, orgId, ChannelScope.ORGANIZATION);
    };
    /**
     * Subcribes to channel for occupany tracking
     */
    RealtimeService.prototype.subscribeToPresenceChannel = function (channel, orgId, cb) {
        return this.subscribe({ channel: channel, cb: cb, topic: "[meta]occupancy" }, orgId, ChannelScope.ORGANIZATION);
    };
    /**
     * Deregister a message listener scoped to Organization channel.
     */
    RealtimeService.prototype.unsubscribeFromOrganizationChannel = function (_a, orgId) {
        var channel = _a.channel, topic = _a.topic, cb = _a.cb;
        return this.unsubscribe({ channel: channel, topic: topic, cb: cb }, orgId, ChannelScope.ORGANIZATION);
    };
    /**
     * Publish to CRM channel.
     */
    RealtimeService.prototype.publishToCrmChannel = function (channel, orgId, accountId) {
        var crmChannel = this.getOrganizationChannel(channel, orgId);
        return crmChannel.publish("accountInfo", { accountIdentifier: accountId });
    };
    /**
     * Enters the presence set for the channel.
     */
    RealtimeService.prototype.presenceEnter = function (channel, orgId, event) {
        var channelInstance = this.getChannel(channel, orgId, ChannelScope.ORGANIZATION);
        return channelInstance.presence.enter(event);
    };
    RealtimeService.prototype.presenceLeave = function (channel, orgId) {
        var channelInstance = this.getChannel(channel, orgId, ChannelScope.ORGANIZATION);
        return channelInstance.presence.leave();
    };
    RealtimeService.prototype.sendResponseEvent = function (topic, message) {
        var _a = this.store.getters["chatbotStore/currentAmp"], id = _a.id, organizationId = _a.organizationId;
        var orgChannel = [id, this.clientId, "events", "response"].join(":");
        var channel = this.getChannel(orgChannel, organizationId, ChannelScope.ORGANIZATION);
        channel.publish(topic, message);
    };
    /**
     * Open and maintain a connection to Ably.
     */
    RealtimeService.prototype.connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.realtime.connection.state !== "connected")) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.realtime.connection.once("connected")];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Subscribe to messages on this channel.
     * The caller supplies a listener function, which is called each time one or more messages arrives on the channel.
     * If a topic is present, subscribes to the specified topic.
     */
    RealtimeService.prototype.subscribe = function (_a, orgId, scope) {
        var channel = _a.channel, topic = _a.topic, cb = _a.cb;
        return __awaiter(this, void 0, void 0, function () {
            var channelInstance;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.connect()];
                    case 1:
                        _b.sent();
                        if (!scope) {
                            throw new Error("Scope is required");
                        }
                        channelInstance = this.getChannel(channel, orgId, scope);
                        if (!cb) {
                            throw new Error("Callback is required");
                        }
                        if (topic) {
                            return [2 /*return*/, channelInstance.subscribe(topic, cb)];
                        }
                        return [2 /*return*/, channelInstance.subscribe(cb)];
                }
            });
        });
    };
    /**
     * Deregisters a specific listener that is registered to receive messages on the channel.
     * If a topic is present, unsubscribes from the specified topic.
     */
    RealtimeService.prototype.unsubscribe = function (_a, orgId, scope) {
        var channel = _a.channel, topic = _a.topic, cb = _a.cb;
        return __awaiter(this, void 0, void 0, function () {
            var channelInstance;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.connect()];
                    case 1:
                        _b.sent();
                        if (!scope) {
                            throw new Error("Scope is required");
                        }
                        channelInstance = this.getChannel(channel, orgId, scope);
                        if (topic) {
                            if (!cb) {
                                throw new Error("Callback is required");
                            }
                            return [2 /*return*/, channelInstance.unsubscribe(topic, cb)];
                        }
                        if (cb) {
                            return [2 /*return*/, channelInstance.unsubscribe(cb)];
                        }
                        return [2 /*return*/, channelInstance.unsubscribe()];
                }
            });
        });
    };
    /**
     * Creates or returns the scoped channel object.
     */
    RealtimeService.prototype.getChannel = function (channel, orgId, scope) {
        if (!channel) {
            throw new Error("Channel is required");
        }
        if (!scope) {
            throw new Error("Scope is required");
        }
        switch (scope) {
            case ChannelScope.ORGANIZATION:
                return this.getOrganizationChannel(channel, orgId);
            default:
                throw new Error("Unsupported channel scope: ".concat(scope));
        }
    };
    RealtimeService.prototype.getOrganizationChannel = function (channel, orgId) {
        return this.realtime.channels.get("".concat(orgId, ":").concat(channel));
    };
    return RealtimeService;
}());
exports.RealtimeService = RealtimeService;
